import {VueReCaptcha} from 'vue-recaptcha-v3';
import Vue from 'vue';

Vue.use(VueReCaptcha, {
	siteKey: window.recaptchaSiteKey
});



// WEBPACK FOOTER //
// ../source/common/recaptcha-v3/recaptcha-v3.js